import React, { createContext, useState, useEffect } from "react";
import { KnowledgeBaseApi } from "../../Util/UtilApi";

export const KnowledgeBaseContext = createContext();

const KnowledgeBaseProvider = ({ children }) => {
  const [categories, setCategories] = useState([]);
  const [articles, setArticles] = useState([]);
  const [individualArticle, setIndividualArticle] = useState(null);
  const [selectedrecordid, setSelectedRecordid] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [searchString, setSearchString] = useState("");
  const [categoryId, setCategoryId] = useState([]);
  const [searchCategories, setSearchCategories] = useState([]);
  const [selectedCategoryName,setSelectedCategoryName]=useState("");
  const [mobileOpenSideBar, setMobileOpensideBar] = useState(false);
  const [categoryName, setCategoryName] = useState("");
  const transformData = (data) => {
    // Group by category recordid to avoid duplicates
    const categoryMap = data.reduce((acc, item) => {
      const category = item.knowledgebasecategoryknowledgebasearticleid;
      const recordid = category.recordid;

      if (!acc[recordid]) {
        acc[recordid] = {
          description: category.description,
          id: category.id,
          isactive: category.isactive,
          name: category.name,
          noofarticles: 0,
          recordid: category.recordid,
          articles: [] // store article details (id + name)
        };
      }

      acc[recordid].noofarticles += 1;
      acc[recordid].articles.push({
        articleId: item.recordid,
        articleName: item.name
      });

      return acc;
    }, {});

    // Convert map to array
    return Object.values(categoryMap);
  };



  const knowledgebase = async () => {
    try {
      const response = await KnowledgeBaseApi();
      const categoriesData = response.data.categories || [];
      const articlesData = response.data.articles || [];

      const updatedArticles = articlesData.map((article) => {
        const matchingCategory = categoriesData.find(
          (category) =>
            category.recordid ===
            article.knowledgebasecategoryknowledgebasearticleid.recordid
        );
        return {
          ...article,
          knowledgebasecategoryknowledgebasearticleid: {
            ...article.knowledgebasecategoryknowledgebasearticleid,
            isactive: matchingCategory ? matchingCategory.isactive : false,
            description: matchingCategory ? matchingCategory.description : ""
          },
        };
      });

      const tranformedData = transformData(updatedArticles);
      setCategories(tranformedData);
      setArticles(updatedArticles);


      // const articleResponse = updatedArticles.find(
      //   (item) =>
      //     item.knowledgebasecategoryknowledgebasearticleid.recordid ===
      //     categoryId
      // );

      // setSelectedRecordid(articleResponse?.recordid);
    } catch (err) {
      console.error("Error fetching knowledgebase:", err);
    }
  };

  const individualKnowledgeBase = async () => {
    if (!selectedrecordid) return;
    try {
      const response = await KnowledgeBaseApi({
        recordid: selectedrecordid,
      });
      setIndividualArticle(response.data.articles[0]);
    } catch (err) {
      console.error("Error fetching article:", err);
    }
  };

  const searchKnowledgeBase = async () => {
    try {
      let apiParams = {
        name: searchString
      };


      const response = await KnowledgeBaseApi(apiParams);
      const articlesData = response.data.articles || [];
      const categoriesData = response.data.categories || [];

      const updatedArticles = articlesData.map((article) => {
        const matchingCategory = categoriesData.find(
          (category) =>
            category.recordid ===
            article.knowledgebasecategoryknowledgebasearticleid.recordid
        );
        return {
          ...article,
          knowledgebasecategoryknowledgebasearticleid: {
            ...article.knowledgebasecategoryknowledgebasearticleid,
            isactive: matchingCategory ? matchingCategory.isactive : false,
            description: matchingCategory ? matchingCategory.description : ""
          },
        };
      });
      const tranformedData = transformData(updatedArticles);
      setCategories(tranformedData);
      // setCategories(categoriesData);
      setArticles(updatedArticles);
    } catch (err) {
      console.error("Error fetching categories:", err);
    }
  };

  useEffect(() => {
    knowledgebase();
  }, [categoryId]);

  useEffect(() => {
    if (selectedrecordid) {
      individualKnowledgeBase();
    }
  }, [selectedrecordid]);

  useEffect(() => {
    if (searchString) {

      searchKnowledgeBase();
    }
  }, [searchString]);



  return (
    <KnowledgeBaseContext.Provider
      value={{
        categories,
        articles,
        selectedrecordid,
        setSelectedRecordid,
        setCategoryId,
        knowledgebase,
        setCategoryName,
        mobileOpenSideBar,
        setMobileOpensideBar,
        selectedCategoryName,
        setSelectedCategoryName,
        searchCategories,
        individualArticle,
        searchTerm,
        searchString,
        setSearchString,
        setSearchTerm,
        categoryName,
      }}
    >
      {children}
    </KnowledgeBaseContext.Provider>
  );
};

export default KnowledgeBaseProvider;